import React, { useState, useCallback } from 'react';
import i18next from 'i18next';
import OptionBox from '../../../StyledComponents/OptionBox';
import { OptionBoxHeading, OptionBoxContent } from '../../../StyledComponents/OptionBox/wrapper';
import { ButtonInline } from '../../../StyledComponents/Button';
import { numberSeparator } from '../../../utils/formats';
import useLoanCalculation from '../Hooks/useLoan';
import { FinancialOption } from '../../../@types/codegen/types';
import LoanModal from './LoanModal';

interface LoanProps {
  id: string;
  financialOption: FinancialOption;
}

const Loan = ({ id, financialOption }: LoanProps) => {
  const [modal, setModal] = useState(false);
  const toggleModal = useCallback(() => setModal(!modal), [modal]);

  const { data } = useLoanCalculation(
    id,
    financialOption.duration?.current,
    financialOption.downPayment?.current,
    financialOption.residual?.current,
    financialOption.identifier
  );

  const interest = data?.loan?.interest;
  const duration = data?.loan?.duration?.current;
  const monthlyCost = data?.loan?.monthlyCost;

  const logo = financialOption?.logotype || financialOption?.image || undefined;

  // Skeleton?
  if (
    financialOption.loanAmount === undefined ||
    financialOption.loanAmount === null ||
    interest === undefined ||
    duration === undefined ||
    monthlyCost === undefined ||
    interest === null ||
    duration === null ||
    monthlyCost === null
  ) {
    return (
      <OptionBox logo={logo} logoAlt="Logotyp">
        <OptionBoxHeading>{i18next.t('other.loading')}</OptionBoxHeading>
        <OptionBoxContent>
          <p>{i18next.t('other.loading')}</p>
        </OptionBoxContent>
      </OptionBox>
    );
  }

  return (
    <>
      {modal && <LoanModal id={id} financialOption={financialOption} onClose={toggleModal} />}
      <OptionBox logo={logo} logoAlt={i18next.t('common.logotype') || ''}>
        <>
          <OptionBoxHeading>{`${numberSeparator(monthlyCost)} ${i18next.t(
            'currency.monthly'
          )}*`}</OptionBoxHeading>

          <OptionBoxContent>
            <p>
              {financialOption.loanAmount && duration
                ? i18next.t('item.financialOptions.payInInstallmentsDetailed', {
                    amount: `${numberSeparator(financialOption.loanAmount)} ${i18next.t(
                      'currency.default'
                    )}`,
                    duration,
                  })
                : i18next.t('item.financialOptions.payInInstallments')}
            </p>

            <p>
              *
              {i18next.t('item.financialOptions.disclaimer', {
                interest: `${(interest * 100).toFixed(2)}%`,
              })}{' '}
              <ButtonInline onClick={toggleModal} title={i18next.t('common.readMore') || ''}>
                {i18next.t('common.readMore')}
              </ButtonInline>
            </p>
          </OptionBoxContent>
        </>
      </OptionBox>
    </>
  );
};

export default Loan;
